export const isLoginPage = (pathname: string) =>
  pathname === '/support' ||
  pathname === '/login' ||
  pathname === '/wrong-entity' ||
  pathname === '/forgot-password' ||
  pathname === '/sign-up'
